import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

const READ_EXPERIMENT_WITHOUT_ACTIVATION = { canActivate: false }

export function useFixedFlashLengthOfStayExperimentState(canActivate = false) {
  const { isAnyVariant, variation } = useExperiment(
    Experiments.croFixedFlashLengthOfStay,
    canActivate ? undefined : READ_EXPERIMENT_WITHOUT_ACTIVATION,
  )

  // Expose variation (not just isAnyVariant) so calendar fetch can react to client-side
  // rebucketing — e.g. Optimizely preview, post-login sync, or a late SSR decision.
  return {
    isEnabled: isAnyVariant,
    variation,
  }
}

function useFixedFlashLengthOfStayExperiment(canActivate = false): boolean {
  return useFixedFlashLengthOfStayExperimentState(canActivate).isEnabled
}

export default useFixedFlashLengthOfStayExperiment
